import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
	arrow: {
	},
	tooltip: {
		backgroundColor: '#000A',
		borderRadius: 6,
    padding: theme.spacing(1, 2)
	},
  tooltipText: {
    color: theme.palette.common.white,
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  list: {
    padding: theme.spacing(1, 1)
  }
}));

export default styles;
